<template>
    <div v-if="totalCount">
        <a class="inline-link footer-selected" @click.stop="scrollTo('#products-search-selected')">
            <b><i>{{ $tc('Selected {$n} product', totalCount) }}</i></b>
        </a>
    </div>
</template>

<script>
    const VueScrollTo = require('vue-scrollto');
    export default {
        name: "TheProductsSearchFooter",
        computed: {
            totalCount() {
                return this.$store.state.ProductSearchModule.selectedProducts.list.length;
            }
        },
        methods: {
            scrollTo(elem) {
                VueScrollTo.scrollTo(elem, 500, {
                    container: '#products-search-content',
                    offset: -50
                });
                this.$store.commit('ProductSearchModule/updateOpenedStatus', true);
            }
        }
    }
</script>
<style scoped>
    .footer-selected { background: #ffb; padding: 5px; border-radius: 5px; }
</style>